import { graphql } from '@/generated/gql';

export const PROCUREMENT_KNOWLEDGE_DOCUMENT_FRAGMENT = graphql(/* GraphQL */ `
  fragment ProcurementKnowledgeDocument on SvbrgDocument {
    id
    fileId
    fileName
    title
    description
    updatedAt
    language
    mimeType
    variant
    url
  }
`);

export const PROCUREMENT_KNOWLEDGE_ADD_MUTATION = graphql(/* GraphQL */ `
  mutation AddProcurementKnowledgeDocument($input: SvbrgDocumentUpload!) {
    sevenbridges {
      document {
        upload(data: $input) {
          ...ProcurementKnowledgeDocument
        }
      }
    }
  }
`);

export const PROCUREMENT_KNOWLEDGE_UPDATE_METADATA_MUTATION = graphql(/* GraphQL */ `
  mutation UpdateProcurementKnowledgeDocumentMetadata($input: SvbrgDocumentUpdateMetadata!) {
    sevenbridges {
      document {
        updateMetadata(data: $input) {
          ...ProcurementKnowledgeDocument
        }
      }
    }
  }
`);
